<template>
  <Dialog
    top=""
    custom-class="pg-dialog pg-dialog-table"
    :title="title"
    :visible="showDrawer"
    :modal="modal"
    :before-close="onCancel"
    :append-to-body="appendToBody"
    :width="width"
    @close="close"
    @closed="closed"
    @open="init"
  >
    <!-- tip -->
    <div v-if="tip" class="pg-dialog-table__tip"><i class="el-icon-warning"></i>{{ tip }}</div>
    <!-- content:search -->
    <div class="pg-dialog-table__content flex">
      <!-- 高级查询-表单 -->
      <PgCriteriaFormDrawer
        v-if="criteriaSearch && !readonly && !!queryForm?.items?.length > 0"
        @search="getData"
        :formData="queryData"
        :formItems="queryForm"
        @clear="PgCriteriaFormClear"
      ></PgCriteriaFormDrawer>
      <!-- input查询框 -->
      <PgInput
        v-if="dataUrl && !readonly && !criteriaSearch && isShowInput"
        prefix-icon="el-icon-search"
        size="medium"
        v-model="keyword"
        :placeholder="placeholder"
        clearable
        @enter="search"
      ></PgInput>

      <!-- content:table -->
      <PgTable
        :data="data"
        class="page-dialog-table__table"
        ref="tableRef"
        :seqShow="seqShow"
        :idPrefix="idPrefix"
        :height="height"
        :checkboxConfig="{ ...checkboxConfig }"
        :loading="loading"
        :column="columns"
        :seachKeys="seachKeys"
        :seachPlaceholder="seachPlaceholder"
        :hideSelectAll="hideSelectAll"
        :isIconSelection="!readonly && isIconSelection"
        :isSelection="!readonly && isSelection"
        :rowConfig="rowConfig"
        :pageSize="page.pageSize"
        :pageSizes="pageSizes"
        :defaultSearchIcon="defaultSearchIcon"
        :current-page="page.pageNo"
        :showPagination="showPagination && !!dataUrl"
        :extendCompileData="{ extendData }"
        @size-change="sizeChange"
        @current-change="currentChange"
        @checkbox-change="(param) => checkboxChangeAndSumit(param)"
        @checkbox-all="checkboxAll"
        @row-change="rowChange"
        @column-custom="getColumns"
        :errorRow="errorRow"
      ></PgTable>
    </div>

    <!-- footer -->
    <template v-if="showFooter && !readonly && !isSelectSubmit" #footer>
      <slot name="footer">
        <ElButton
          style="min-width: 120px"
          round
          size="medium"
          @click="handleCancel"
          v-if="props.cacelText"
          >{{ props.cacelText }}</ElButton
        >
        <ElButton
          v-if="singleSelect"
          style="min-width: 120px"
          type="primary"
          round
          @click="submit"
          :loading="sureLoading"
          :disabled="isSelection && selections.length !== 1"
        >
          确定
        </ElButton>
        <ElButton
          v-else-if="!singleShowCancel"
          style="min-width: 120px"
          type="primary"
          round
          @click="submit"
          :loading="sureLoading"
          :disabled="
            disabledSubmitFn
              ? disabledSubmitFn(data, selections, isSelection)
              : isSelection && selections.length == 0
          "
        >
          确定
        </ElButton>
      </slot>
    </template>
  </Dialog>
</template>
<script setup>
import { getCurrentInstance, ref, toRefs } from 'vue'
import { Dialog } from 'element-ui'
import { PgCriteriaFormDrawer, useCriteriaQueryDrawer } from '../../criteria-form/index'
import { PgTable } from '../../table/index'
// import { PgPagination } from '../../pagination/index'
import { pgMessage } from '../../message/index'
// hook
import { useGetForm } from '../hook/use-get-form'
import { useSure } from '../hook/use-sure'
import {
  useDrawerPack,
  beforValueOldActionProps,
  useBeforValueOldActions,
} from '../../../hooks/index'
import { useTable } from '../hook/use-table'
import { useQuery } from '../hook/use-query'
import { usePagination } from '../hook/use-pagination'

const props = defineProps({
  appendToBody: {
    type: Boolean,
    default: true,
  },
  visible: {
    type: Boolean,
    default: true,
  },
  modal: {
    type: Boolean,
    default: true,
  },
  title: {
    type: String,
    default: '选择',
  },
  tip: { type: String },
  width: {
    type: String,
    default: '1002px',
  },
  height: {
    type: [String, Number],
    default: 'auto',
  },
  // 是否隐藏全选
  hideSelectAll: Boolean,
  seqShow: { type: Boolean, default: true },
  // 是否显示分页，默认: 显示
  showPagination: { type: Boolean, default: true },
  showFooter: { type: Boolean, default: true },
  // 是否是选中明细行直接提交
  isSelectSubmit: { type: Boolean, default: false },
  // 表格使用高级查询作为条件
  criteriaSearch: {
    type: Boolean,
    default: false,
  },
  // 高级查询的url
  criteriaUrl: {
    type: String,
    default: 'rest/ezcomp/dict/criteria/fetch/',
  },
  criteriaColumn: {
    type: Number,
    default: 6,
  },
  // 高级查询的code
  criteriaCode: String,
  // Table -----------------------------------------------------------
  data: Array,
  // 表格查询 外部补充条件
  dataParameters: Object,
  // 表格-数据请求url
  dataUrl: String,
  dataMethod: String,
  // 是否显示icon添加
  isIconSelection: {
    type: Boolean,
    default: false,
  },
  isSelection: {
    type: Boolean,
    default: true,
  },
  //是否单选
  singleSelect: {
    type: Boolean,
    default: false,
  },
  //是否单选
  singleShowCancel: {
    type: Boolean,
    default: false,
  },
  // 表格-分页条数[10, 20,...]
  pageSizes: Array,
  // 表格-默认显示条数
  pageSize: {
    type: Number,
    default: 10,
  },
  rowConfig: {
    type: Object,
    default: () => ({ keyField: 'id' }),
  },
  // 表格-code
  columnTableCode: String,
  // 表格-列定义url
  columnUrl: {
    type: String,
    default: 'rest/ezcomp/dict/table/fetch/',
  },
  // 表格-列定义
  column: [Array, Object],
  // 表格-id前缀
  idPrefix: String,
  checkboxConfig: {
    type: Object,
    default: () => ({ checkField: 'checked' }),
  },
  // -----------------------------------------------------------
  placeholder: {
    type: String,
    default: '科室名称',
  },
  keywordPath: {
    type: String,
    default: 'keyword',
  },
  successMsgKey: { type: String, default: '' },
  successMessage: { type: String, default: '提交成功' },
  extendData: Object,
  formModel: Object,
  formUrl: String,
  formParam: Object,
  submitUrl: String,
  submitParams: Object,
  submitField: {
    type: String,
    default: 'ids',
  },
  submitFieldId: {
    type: String,
    default: 'id',
  },
  onOK: Function,
  readonly: { type: Boolean, default: false },
  errorRow: String,
  cacelText: {
    type: String,
    default: '取消',
  },
  seachKeys: {
    type: Array,
    default: () => [],
  },
  seachPlaceholder: String,
  defaultSearchIcon: String,
  isShowInput: {
    type: Boolean,
    default: true,
  },
  // 不勾选可点击【确认】，处理函数。返回 false 则不勾选也可点击【确认】，返回 true 则需要再判断是否有勾选，有勾选才可点击
  disabledSubmitFn: { type: Function },
  ...beforValueOldActionProps,
})
const { proxy } = getCurrentInstance()

const emit = defineEmits(['update:visible', 'close', 'closed', 'on-cancel', 'on-ok'])

const keyword = ref('')
const {
  formModel,
  formUrl,
  formParam,
  visible,
  successMsgKey,
  successMessage,
  submitUrl,
  submitField,
  submitFieldId,
  submitParams,
} = toRefs(props)
const { beforeEmit } = useBeforValueOldActions({
  store: props.store,
  beforValueAction: props.beforValueAction,
  emit,
})
const { showDrawer, close, closed, onCancel, closeDrawer, handleCancel } = useDrawerPack(
  visible,
  emit
)
// 高级查询-表单
const { getCriteria, queryForm, queryData, setQueryForm, updateQueryData, setDefaultQuery } =
  useCriteriaQueryDrawer(
    props.criteriaUrl,
    props.criteriaCode,
    props.criteriaColumn,
    props.defaultQueryParameters
  )
// 表单
const { formData, getFormData } = useGetForm({ formModel, formUrl, formParam })
const { sureLoading, sure } = useSure({ formData, submitUrl })
// 表格
const { columns, getColumns } = useTable({
  columnUrl: props.columnUrl,
  columnTableCode: props.columnTableCode,
  column: props.column,
})
// 分页
const { page, changePaginationSize, changePaginationCurrent } = usePagination({ props })
// 查询
const {
  tableRef,
  // totalCount,
  selections,
  loading,
  search,
  getData,
  reload,
  checkboxAll,
  checkboxChange,
} = useQuery({
  props,
  page,
  keyword,
  emit,
  queryData,
})

const sizeChange = (pageSize) => {
  changePaginationSize(pageSize)
  reload()
}

// const cellDblclick=(param)=>{
//   if(props.singleSelect){
//     emit('on-ok', param?.row)
//   }
// }

const currentChange = (pageNo) => {
  changePaginationCurrent(pageNo)
  getData()
}

const rowChange = (param) => {
  emit('row-change', param)
}

const submit = async () => {
  if (props.readonly) {
    console.warn('组件 pg-dialog-table 目前为【只读】状态！')
    return
  }
  const ids = selections.value.map((im) => im[submitFieldId.value ?? 'id'])
  const param = {}
  param[submitField.value ?? 'ids'] = ids
  if (submitParams.value) Object.assign(param, submitParams.value)

  const res = await sure(param, selections)

  if (res) {
    if (props.onOK) {
      props.onOK(res)
    } else if (props.store && props.beforValueAction) {
      // 对外抛出数据，可供其他页面/组件使用
      const options = {
        data: res,
        vue: proxy,
      }

      // 兼容老组件的 beforValueAction 执行 beforeEmit，内部处理完后对外抛出 input 事件和值
      const flag = await beforeEmit(options)
      if (flag) {
        closeDrawer()
        emit('on-ok', res)
      }
    } else {
      closeDrawer()
      if (successMsgKey.value) {
        pgMessage.success(res?.[successMsgKey.value] ?? '成功')
      } else {
        //增加判断 bug 43688 让所有的弹窗提交成功显示 提交成功 提示
        pgMessage.success(successMessage.value)
      }
      emit('on-ok', res)
    }
  }
}

const checkboxChangeAndSumit = async (param) => {
  checkboxChange(param)

  if (props.isSelectSubmit) await submit()
}

// -----------------------------------高级查询与input-区域---------------------------------------
// 高级查询-表单-清空
const PgCriteriaFormClear = () => {
  updateQueryData({})
}
// --------------------------------------通用操作----------------------------------------------
// 页面初始化
const init = async () => {
  // 需要使用高级查询作为条件时再去请求高级查询
  const promiseQueue = props.criteriaSearch
    ? [getCriteria(), getColumns(), getFormData()]
    : [getColumns(), getFormData()]
  Promise.all(promiseQueue).then(([res]) => {
    // 请求数据
    getData()
    if (!props.criteriaSearch) return false
    setQueryForm(res[0]) // 2.设置高级查询-表单
    if (res[1] && res[2]) {
      // 有默认值或者有storage
      updateQueryData(Object.assign(res[1], res[2]))
    } else if (res[2]) {
      setDefaultQuery(res[2])
    }
  })
}
</script>
<style lang="scss">
@import '../style/dialog-table.scss';
@import '../../page-query-top-search/style/query-top-search-table.scss';
</style>
